
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as RaceIcon } from "../fontello/icons/svg/ic_race.svg"


const Race = ({ ...props }) => (
  <SvgIcon
    component={RaceIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Race
